import { render, staticRenderFns } from "./RecentWithdrawal.vue?vue&type=template&id=7727efdd&"
import script from "./RecentWithdrawal.vue?vue&type=script&lang=js&"
export * from "./RecentWithdrawal.vue?vue&type=script&lang=js&"
import style0 from "./RecentWithdrawal.vue?vue&type=style&index=0&id=7727efdd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VChip,VCol,VImg,VLayout,VListItem,VListItemAvatar,VListItemContent,VListItemTitle,VRow})
